import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import SettingsView from 'Components/settings/common/SettingsPage';
import { ENDPOINTS } from 'src/constants';
import { useLocation } from "react-router-dom";
import { useLazyQuery } from '@apollo/client';
import { PAGE_INFORMATION_QUERY } from 'Graph/SiteGraph';
import PageLoadingSkeleton from 'Components/skeletons/PageLoadingSkeleton';

const UserSettingsView = () => {
  const location = useLocation();
  const [pageInformationData, setPageInformationData] = useState(null)
  const [getLazyPageInformation, lazyPageInformation] = useLazyQuery(PAGE_INFORMATION_QUERY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only', // Used for first execution
    nextFetchPolicy: 'cache-first', // Used for subsequent executions
  });
  useEffect(() => {
    getLazyPageInformation({
      variables: { sidebarURL: location.pathname },
      onCompleted: ((info) => {
        setPageInformationData(info.pageConn.edges.map((edge) => edge.node))
      })
    })
  }, [])
  if (pageInformationData === null) return <PageLoadingSkeleton variant={"rectangular"} marginx={0} marginy={0} count={1} height={500} />


  return (
    <React.StrictMode>
      <Helmet>
        <title>{pageInformationData[0].title}</title>
      </Helmet>
      <SettingsView rootURL={`${ENDPOINTS.settingsUrl}`} label="User Settings" />

    </React.StrictMode>
  )
}

export default UserSettingsView;
